// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_pay_pay_module_ts":"33c902ab55d5b538","node_modules_lottie-web_build_player_lottie_js":"2a439a89c8333683"}[chunkId] + ".js";
};